jQuery(function($) {
  	 

     /* ******************* */
   /* FITVID - POUR VIDEO RESPONSIVE  */
   /* ******************* */

   $(".ContainerVideoWidth").fitVids();

  /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

  
    $('.btnHomeDown').click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 60 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });


  /* ********************************************** */
/* **** SIMPLE SCRILLBAR  ************* */
/* ********************************************** */

  if($('.myscrollbar').length){
    var el = document.querySelector('.myscrollbar');
    SimpleScrollbar.initEl(el);
  } 

/* ********************************************** */
/* **** VAR  ************* */
/* ********************************************** */

  var LARGEUR_MAX_MOBILE = 1023;
  var l_window = $(window).width();
  var header = $("#masthead");
  var site_navigation = $('#site-navigation');

  
   /*************/
    /* OUVERTURE / FERMETURE DU MENU EXPERIENCE */
    /*************/
    $('.btn-open-news').parent().next().hide();
    $('.btn-open-news').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
           $(this).find('.Buton-Title').text('Fermer l\'actualité');
           $(this).attr('aria-expanded', "true");
           $(this).parent().next().slideDown(500);
           $(this).find('.Buton-Icon').html('<i class="icon-to_top"></i>');
         }else{
            $(this).find('.Buton-Title').text('En savoir plus');
            $(this).attr('aria-expanded', "false");
            $(this).parent().next().slideUp(500);
            $(this).find('.Buton-Icon').html('<i class="icon-to_bottom"></i>');
         }
         e.preventDefault();
    });


    /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
    if(l_window > 1023){
      action_on_scroll();
    }
    });

    function action_on_scroll(){
      l_window = parseInt($(window).width());
         if ($(window).scrollTop() > 50){
            header.addClass("Masthead--sticky");
            $("body").addClass('header--sticky');
          }else{
             header.removeClass("Masthead--sticky");
             $("body").removeClass('header--sticky');
          }
   }




  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


});
